import { createTheme } from '@mui/material/styles';

const createFrecallTheme = (mode = 'light') => {
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: '#005f50',
        dark: '#004d40',
        light: '#3b8d7f',
      },
      secondary: {
        main: isDark ? '#d3d7dc' : '#1f2328',
      },
      background: {
        default: isDark ? '#0f1413' : '#f1f6f4',
        paper: isDark ? '#151d1b' : '#f8fbfa',
      },
      text: {
        primary: isDark ? '#edf3f1' : '#1f2328',
        secondary: isDark ? '#a8b3af' : '#5b636a',
      },
    },
    shape: {
      borderRadius: 12,
    },
    spacing: 8,
    typography: {
      fontFamily: '"Avenir Next", Avenir, "Segoe UI", sans-serif',
      h5: {
        fontWeight: 700,
        letterSpacing: -0.3,
      },
      h6: {
        fontWeight: 650,
        letterSpacing: -0.2,
      },
      subtitle2: {
        fontWeight: 600,
        letterSpacing: 0.2,
      },
      button: {
        textTransform: 'none',
        fontWeight: 600,
        letterSpacing: 0.1,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: isDark ? '#0f1413' : '#f1f6f4',
            color: isDark ? '#edf3f1' : '#1f2328',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            borderColor: isDark ? 'rgba(123, 177, 160, 0.2)' : 'rgba(0, 77, 64, 0.14)',
            boxShadow: isDark ?
              '0 10px 24px rgba(0, 0, 0, 0.36)' :
              '0 6px 20px rgba(18, 30, 26, 0.12)',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            minHeight: 40,
            transition: 'all 160ms ease',
          },
          outlined: {
            borderWidth: 1.2,
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            transition: 'all 140ms ease',
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 999,
            fontWeight: 600,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            backgroundColor: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(255,255,255,0.65)',
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderWidth: 1.5,
            },
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          size: 'small',
        },
      },
    },
  });
};

export default createFrecallTheme;
